import { render } from "./BaseTextarea.vue?vue&type=template&id=540ad100"
import script from "./BaseTextarea.vue?vue&type=script&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&lang=js"
script.render = render

export default script